import classNames from 'classnames';
import React from 'react';
import type { TagBase } from 'types/tag';
import { type TagStyle, tagDisplay, tagStructure } from './datatable/datatable.types';
import styles from './HourTags.module.scss';
import { Close } from './Icons';

interface Props {
  className?: string;
  children?: React.ReactNode;
  onClickTag?: (tagId: number) => void;
  hasDarkBackground?: boolean;
  selectedTag?: TagBase;
  tags?: Array<TagBase>;
  tagStyle?: TagStyle;
}

const HourTags = React.memo<Props>(
  ({ children, className, hasDarkBackground, onClickTag, selectedTag, tags, tagStyle }) => {
    return (
      <ul
        className={classNames(styles.tags, className, {
          [styles.hasDarkBackground]: hasDarkBackground,
          [styles.clickableTags]: onClickTag,
        })}
      >
        {children}
        {(selectedTag ? [selectedTag] : tags)?.map(tag => {
          const altText = `Emoji for ${tag.name}`;
          const isSelected = selectedTag?.id === tag.id;

          return (
            <li
              key={tag.id}
              className={classNames({
                [styles.selected]: isSelected,
              })}
              onClick={() => onClickTag?.(tag.id)}
              data-testid="hour_tag"
            >
              {(!tagStyle ||
                (tagStyle?.tagStructure === tagStructure.Values.consolidated &&
                  tagStyle?.tagDisplay !== tagDisplay.Values.tagLists)) && (
                <img src={tag.emoji} className={styles.emoji} alt={altText} />
              )}
              {!tagStyle && tag.name}
              {tagStyle?.tagStructure === tagStructure.Values.consolidated &&
                tagStyle?.tagDisplay === tagDisplay.Values.tags &&
                tag.name}
              {tagStyle?.tagStructure === tagStructure.Values.consolidated &&
                tagStyle?.tagDisplay === tagDisplay.Values.listsAndTags &&
                `${tag.parent?.name}; ${tag.name}`}
              {tagStyle?.tagStructure === tagStructure.Values.consolidated &&
                tagStyle?.tagDisplay === tagDisplay.Values.tagLists &&
                tag.parent?.name}
              {isSelected && <Close className={styles.removeIcon} width="8" height="8" />}
            </li>
          );
        })}
      </ul>
    );
  }
);

HourTags.displayName = 'HourTags';

export default HourTags;
